import React from 'react';
export const TwitterIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon">
      <svg id="icon-twitter" viewBox="0 0 1024 1024">
        <title>Twitter</title>
        <path
          className="path1"
          d="M1024 194.432c-37.696 16.704-78.144 28.032-120.64 33.088 43.392-25.984 76.672-67.2 92.352-116.224-40.576 24.064-85.568 41.536-133.44 51.008-38.336-40.832-92.928-66.368-153.344-66.368-116.032 0-210.112 94.080-210.112 210.048 0 16.448 1.856 32.512 5.44 47.872-174.592-8.768-329.408-92.416-433.024-219.52-18.112 31.040-28.416 67.136-28.416 105.6 0 72.896 37.056 137.216 93.44 174.848-34.432-1.088-66.816-10.56-95.168-26.304 0 0.896 0 1.728 0 2.624 0 101.76 72.448 186.688 168.512 206.016-17.6 4.8-36.16 7.36-55.36 7.36-13.568 0-26.688-1.344-39.552-3.776 26.752 83.456 104.32 144.192 196.224 145.92-71.872 56.32-162.496 89.92-260.928 89.92-16.96 0-33.664-1.024-50.112-2.944 92.992 59.584 203.392 94.4 322.048 94.4 386.432 0 597.76-320.128 597.76-597.76 0-9.088-0.192-18.176-0.64-27.2 41.088-29.632 76.672-66.624 104.832-108.736z"
        ></path>
      </svg>
    </svg>
  );
};
